import React, { memo } from 'react'
import Modal from 'react-modal'
import PropTypes from 'prop-types'
import styled from '@emotion/styled'

import { ActionButtonText } from 'components/layouts/homepage/buttons'
import customStyles from 'components/modals/styles'
import { ModalFooter } from 'components/modals/components/layout'
import ModalSuperTitle from 'components/modals/components/sTitle'
import { TYPOGRAPHY_21 } from 'theme/theme'

export const ActionButton = styled.button`
  height: 36px;
  background: ${props => props.active ? '#0bf' : '#646770'};
  border-radius: 5px;
  cursor: pointer;
  border: 0;
  margin: 5px 10px;
  width: 184px;
`

const CloseIcon = styled.div`
  position: absolute;
  right: 15px;
  top: 0;
  cursor: pointer;
`

const Wrapper = styled.div`
  display: flex;
  padding: 20px 40px 40px 40px;
  width: 550px;
  max-width: 100%;
`

const Text = styled.div`
  ${TYPOGRAPHY_21}

  overflow-wrap: break-word;
  word-wrap: break-word;
  hyphens: auto;
  margin-bottom: 10px;
  text-align: center;
  color: #7F8289;
  padding: 20px;
`

export const ModalHeader = styled.div`
  position: relative;
  display: flex;
  margin-top: 20px;
  justify-content: center;
`

export const Block = styled.div`
  display: flex;

  @media (max-width: 767px) {
    flex-wrap: wrap;
  }
`

const ButtonWrap = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  @media (max-width: 767px) {
    margin-bottom: 40px;
  }
`

function SignUpModal ({ open, setOpen }) {
  const onClose = () => setOpen(false)

  return (
    <Modal
      isOpen={open}
      onRequestClose={onClose}
      style={customStyles()}>
      <ModalHeader className="h-center">
        <CloseIcon onClick={onClose}><img className="flex" src="/s/icons/modal-close.svg" alt="Close modal" /></CloseIcon>
        <ModalSuperTitle lg>Sign Up as:</ModalSuperTitle>
      </ModalHeader>
      <Wrapper data-test="modal">
        <ModalFooter center>
          <Block>
            <ButtonWrap>
              <Text>Invest in the best late-stage private European tech companies you love:</Text>
              <a href={'/sign-up'} id="signUpInvestors"><ActionButton>
                <ActionButtonText>
                  Investors
                </ActionButtonText>
              </ActionButton></a>
            </ButtonWrap>
            <ButtonWrap>
              <Text>Fund your allocation in the next funding round or sell your shares:</Text>
              <a href={'/sign-up-business'} id="signUpBusiness"><ActionButton active>
                <ActionButtonText active>
                  Shareholders
                </ActionButtonText>
              </ActionButton></a>
            </ButtonWrap>
          </Block>
        </ModalFooter>
      </Wrapper>
    </Modal>
  )
}

SignUpModal.propTypes = {
  open: PropTypes.bool,
  setOpen: PropTypes.func
}

export default memo(SignUpModal)
